import React, { useCallback } from 'react';

import BotLogixPersonSrc from './ambassador_steffen_degraff.png';
import BotLogixCompanySrc from './ambassador_seffen_degraff_BotLogix_logo.png';

import RyanWhitePersonSrc from './ryan-white.png';

import KekoaPersonSrc from './kekoa.png';

export const ambassadorMap = [
  {
    company: 'Steffen deGraaf',
    affiliateId: 'BotLogix',
    logo: BotLogixCompanySrc,
    avatar: BotLogixPersonSrc,
    name: 'Steffen deGraaf',
    position: (
      <span>
        Founder & Chief Creative Officer, BotLogix
        <br />
        Conversational Marketing with Intelligence
      </span>
    ),
    quote: (
      <span>
        Clients of my agency are generating hundreds of thousands in revenue
        through the leads and engagements created through Customers.ai.
        <br />
        <br />I can't overstate the power of the OmniChat platform for growing
        an audience and driving sales and conversions from Instagram, Facebook
        Messenger, text messaging and website visitors.
      </span>
    ),
    subtitle: 'Get Customers.ai Startup Edition for $119/mo',
    code: (
      <>
        Friends of Steffen deGraaf:{' '}
        <span style={{ color: 'black' }}>
          <strong>Get 50% off first 3 months</strong>
        </span>{' '}
        with code{' '}
        <span style={{ color: 'black' }}>
          "<strong>BOTLOGIX</strong>"
        </span>
      </>
    ),
  },
  {
    company: 'Ryan White',
    affiliateId: 'ceoryanwhite',
    logo: RyanWhitePersonSrc,
    avatar: RyanWhitePersonSrc,
    name: 'Ryan White',
    position: <span>Founder/CEO, Social Revelation Marketing</span>,
    quote: (
      <span>
        I really love how easily you can integrate Customers.ai into your social
        media strategy to lighten the workload and duplicate your efforts which
        allows our team to respond to leads more effectively, have better
        conversation flows, and ultimately give those who reach out to us a
        better experience.
      </span>
    ),
    subtitle: 'Get Customers.ai Startup Edition for $119/mo',
    code: undefined,
  },
  {
    company: 'Kekoa MacAuley',
    affiliateId: 'kekoa',
    logo: KekoaPersonSrc,
    avatar: KekoaPersonSrc,
    name: 'Kekoa MacAuley',
    position: (
      <span>Founder & CEO of Esquared Media and Win With Influence</span>
    ),
    quote: (
      <span>
        I've been using Customers.ai for the past month and it has just been
        insane for my business. We've literally brought on about 12,000 new
        contacts and new leads for our business.
        <br />
        <br />
        Customers.ai has helped tag those users, segment those users into
        different lists, made it super easy for all my VAs to manage those
        leads.
        <br />
        <br />
        We've doubled and almost tripled our sales just in the past month from
        using it. We're also implementing new sales funnels all the time to
        increase that even more. Huge shout out to Larry Kim, Eric Gordon and
        the team at Customers.ai.
        <br />
        <br />
        If you are looking to help automate your sales processes more, help
        manage more clients and more leads, Customers.ai is literally the tool
        for you.
      </span>
    ),
    subtitle: 'Get Customers.ai Startup Edition for $119/mo',
    code: undefined,
  },
];

export const useAffiliateData = () => {
  return useCallback(
    (id: string) =>
      ambassadorMap.find(
        ({ affiliateId }) => id.toLowerCase() === affiliateId.toLowerCase(),
      ),
    [],
  );
};
